import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, PawPrint } from "lucide-react";
import Seo from "@/components/Seo";
import NicoMedia from "@/components/NicoMedia";
import { useLang } from "@/context/LanguageContext";

export default function NicosStory() {
  const { t } = useLang();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const paras = t("nico.reviewBody").split("\n\n");

  return (
    <div data-testid="page-nicos-story">
      <Seo title={t("nico.metaTitle")} description={t("nico.metaDesc")} path="/nicos-story" type="article" />
      <section className="mx-auto max-w-3xl px-6 lg:px-12 py-14 lg:py-20">
        <div className="flex items-center gap-2 text-terracotta">
          <PawPrint size={18} strokeWidth={1.5} />
          <span className="text-sm uppercase tracking-[0.2em]">Hola Movers</span>
        </div>
        <h1 data-testid="nico-title" className="mt-4 font-serif text-4xl sm:text-5xl text-charcoal-800 leading-tight">
          {t("nico.metaTitle")}
        </h1>
        <p data-testid="nico-intro" className="mt-4 text-lg text-charcoal-600">{t("nico.intro")}</p>

        <article className="mt-10 rounded-3xl bg-white border border-sand-200 p-6 sm:p-10 shadow-[0_8px_32px_rgba(44,42,41,0.06)]">
          <h2 className="font-serif text-2xl sm:text-3xl text-charcoal-800">{t("nico.reviewTitle")}</h2>
          <div className="mt-5 space-y-4 text-charcoal-700 leading-relaxed">
            {paras.map((p, i) => (
              <p key={i} data-testid={`nico-review-p-${i}`}>{p}</p>
            ))}
          </div>
        </article>

        <NicoMedia />

        <div className="mt-10 flex flex-col sm:flex-row flex-wrap gap-4">
          <a
            href="/#testimonials"
            data-testid="nico-read-family"
            className="inline-flex items-center gap-2 text-sm font-medium text-terracotta hover:text-terracotta-hover transition-colors"
          >
            {t("nico.readFamily")} <ArrowRight size={16} />
          </a>
        </div>
        <div className="mt-6">
          <Link
            to="/book"
            data-testid="nico-book-cta"
            className="inline-flex items-center gap-2 rounded-full bg-terracotta px-7 py-3 text-white font-medium hover:bg-terracotta-hover transition-colors shadow-sm"
          >
            {t("nico.book")}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
